import { ReactNode } from "react";
import { Heading, Container, Box, Flex, Center } from "@chakra-ui/react";
import Mountains from "public/assets/mountains.min.svg";
import { DEFAULT_APP_NAVBAR_HEIGHT } from "components/Layout/constants";
import FullHeightContent from "components/Layout/FullHeightContent";
import Logo from "components/Layout/NavBar/Logo";

export type Props = {
  children?: ReactNode;
  hasLogo?: boolean;
  heading?: ReactNode;
};

function ErrorPage({ children, hasLogo = false, heading }: Props) {
  return (
    <FullHeightContent
      backgroundColor="lightBlueGrey"
      display="flex"
      flexFlow="column"
      overflow="auto"
      width="100%"
    >
      {hasLogo && (
        <Flex flex="0 0 auto" height={DEFAULT_APP_NAVBAR_HEIGHT}>
          <Logo />
        </Flex>
      )}
      <Container
        as={Center}
        flex="1 1 auto"
        textAlign="center"
        color="magenta.veryDark"
        pos="relative"
      >
        <Box>
          <Box as={Mountains} width="15rem" margin="0 auto" mb={8} />
          {heading && <Heading fontSize="4xl">{heading}</Heading>}
          {children}
        </Box>
      </Container>
    </FullHeightContent>
  );
}

export default ErrorPage;
